import moment from 'moment';

const calMinute = (from: string, to: string): number | null => {
  if (!from || !to) return null;

  // 1) Parse start strictly as ISO
  const start = moment(from, moment.ISO_8601, true);
  if (!start.isValid()) return null;

  // 2) Parse `to` either as ISO or as a clock‐time
  const isoTo = moment(to, moment.ISO_8601, true);
  const clockTo = moment(to, ['H:mm', 'HH:mm', 'h:mm a', 'h:mma'], true);

  const toMoment = isoTo.isValid() ? isoTo : clockTo;
  if (!toMoment.isValid()) return null;

  // 3) Anchor `to`’s time‐of‐day onto start’s DATE
  const end = start.clone().set({
    hour: toMoment.hour(),
    minute: toMoment.minute(),
    second: toMoment.second(),
    millisecond: toMoment.millisecond(),
  });

  // 4) Compute raw diff in minutes (may be negative)
  const rawDiff = end.diff(start, 'minutes');

  // 5) Wrap negative diffs into a 0–1439 range
  const MINUTES_IN_DAY = 24 * 60;
  const diff24 = ((rawDiff % MINUTES_IN_DAY) + MINUTES_IN_DAY) % MINUTES_IN_DAY;

  // 6) Round UP to the next 5-minute boundary
  const rem = diff24 % 5;
  return rem === 0 ? diff24 : diff24 + (5 - rem);
};

export default calMinute;

